var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1486:3480)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1486:3480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 31C62 33.686 59.6809 36.0314 59.0187 38.5088C58.3336 41.072 59.1491 44.259 57.8506 46.5033C56.5335 48.7796 53.3532 49.659 51.5057 51.5064C49.6584 53.3537 48.7791 56.5339 46.5029 57.8509C44.2587 59.1493 41.0719 58.3336 38.5087 59.0187C36.0315 59.6809 33.6861 62 31 62C28.314 62 25.9686 59.6809 23.4912 59.0187C20.928 58.3336 17.741 59.1491 15.4967 57.8506C13.2204 56.5335 12.341 53.3532 10.4936 51.5057C8.64625 49.6584 5.46612 48.7791 4.14912 46.5029C2.85075 44.2588 3.66637 41.0719 2.98125 38.5088C2.31912 36.0315 0 33.6861 0 31C0 28.314 2.31912 25.9686 2.98125 23.4912C3.66637 20.928 2.85087 17.741 4.14937 15.4967C5.4665 13.2204 8.64675 12.341 10.4942 10.4936C12.3416 8.64625 13.2209 5.46613 15.4971 4.14913C17.7412 2.85075 20.9281 3.66638 23.4912 2.98125C25.9685 2.31913 28.3139 0 31 0C33.686 0 36.0314 2.31913 38.5087 2.98125C41.072 3.66638 44.259 2.85088 46.5032 4.14937C48.7796 5.4665 49.659 8.64675 51.5064 10.4943C53.3537 12.3416 56.5339 13.2209 57.8509 15.4971C59.1492 17.7412 58.3336 20.9281 59.0187 23.4912C59.6809 25.9685 62 28.3139 62 31Z",
    fill: "#FFD100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4939 10.4941C8.64638 12.3414 5.46638 13.2208 4.14925 15.497C2.85075 17.7413 3.66638 20.9283 2.98125 23.4915C2.31913 25.9689 0 28.3141 0 31.0003C0 33.6863 2.31913 36.0316 2.98125 38.509C3.66638 41.0722 2.85075 44.259 4.14913 46.5032C5.46613 48.7794 8.64638 49.6587 10.4936 51.506C12.341 53.3535 13.2204 56.5338 15.4968 57.8509C17.741 59.1494 20.928 58.3339 23.4913 59.019C25.9686 59.6812 28.314 62.0003 31 62.0003C33.6861 62.0003 36.0315 59.6812 38.5088 59.019C41.0719 58.3339 44.2588 59.1495 46.5029 57.8512C48.7791 56.5342 49.6584 53.3539 51.5058 51.5067L51.506 51.5064L10.4939 10.4941Z",
    fill: "#FF9500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.001 53C43.1512 53 53.001 43.1503 53.001 31C53.001 18.8497 43.1512 9 31.001 9C18.8507 9 9.00098 18.8497 9.00098 31C9.00098 43.1503 18.8507 53 31.001 53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.001 52.9997C37.0761 52.9997 42.5761 50.5372 46.5574 46.5561L15.4446 15.4434C11.4635 19.4246 9.00098 24.9246 9.00098 30.9997C9.00098 43.15 18.8507 52.9997 31.001 52.9997Z",
    fill: "#FFD100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 50C41.4934 50 50 41.4934 50 31C50 20.5066 41.4934 12 31 12C20.5066 12 12 20.5066 12 31C12 41.4934 20.5066 50 31 50Z",
    fill: "#FF4F19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.565 17.5654C14.1268 21.0037 12 25.7537 12 31.0004C12 41.4938 20.5066 50.0004 31 50.0004C36.2467 50.0004 40.9967 47.8737 44.435 44.4354L17.565 17.5654Z",
    fill: "#E7001E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 41.5001C21.6167 41.5001 21.2329 41.3536 20.94 41.0606C20.354 40.4751 20.354 39.525 20.94 38.9395L38.94 20.9395C39.526 20.3535 40.4751 20.3535 41.0611 20.9395C41.6471 21.525 41.6471 22.4751 41.0611 23.0606L23.0611 41.0606C22.7681 41.3536 22.3842 41.5001 22.0005 41.5001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0005 30.5C21.9682 30.5 19.5005 28.0327 19.5005 25C19.5005 21.9673 21.9682 19.5 25.0005 19.5C28.0327 19.5 30.5005 21.9673 30.5005 25C30.5005 28.0327 28.0327 30.5 25.0005 30.5ZM25.0005 22.5C23.6216 22.5 22.5005 23.6216 22.5005 25C22.5005 26.3784 23.6216 27.5 25.0005 27.5C26.3794 27.5 27.5005 26.3784 27.5005 25C27.5005 23.6216 26.3794 22.5 25.0005 22.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 42.5C33.9678 42.5 31.5 40.0328 31.5 37C31.5 33.9673 33.9678 31.5 37 31.5C40.0323 31.5 42.5 33.9673 42.5 37C42.5 40.0328 40.0323 42.5 37 42.5ZM37 34.5C35.6211 34.5 34.5 35.6216 34.5 37C34.5 38.3784 35.6211 39.5 37 39.5C38.3789 39.5 39.5 38.3784 39.5 37C39.5 35.6216 38.3789 34.5 37 34.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1486:3480",
    x: -2.68155,
    y: 0,
    width: 67.3631,
    height: 67.3631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.68155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.34078
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1486:3480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1486:3480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1486:3480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.48002b21.svg";
export { ForwardRef as ReactComponent };